import React from "react";

import WebinarTable from "components/Cards/WebinarTable";

export default function Webinar() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <WebinarTable />
        </div>
      </div>
    </>
  );
}
